import { render } from "./NewsletterPopup.vue?vue&type=template&id=3dc88102&scoped=true"
import script from "../js/newsletter-popup.js?vue&type=script&lang=js"
export * from "../js/newsletter-popup.js?vue&type=script&lang=js"

import "./NewsletterPopup.vue?vue&type=style&index=0&id=3dc88102&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc88102"]])

export default __exports__